<template>
  <div class="orgTypePage">
    <el-table
      stripe
      :data="orgTypeData"
      style="width: 100%"
      border
      height="100%"
      size="mini"
      row-key="id"
      :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
      default-expand-all
    >
      <el-table-column type="index" width="50" align="center"></el-table-column>
      <el-table-column
        prop="name"
        label="组织类别"
        min-width="110px"
        header-align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="productionLine"
        label="是否生产线"
        width="130px"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span class="textSuccess" v-if="scope.row.productionLine">生产线</span>
          <span class="textWarning" v-else>否</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="enable"
        label="状态"
        align="center"
        width="130px"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span class="textSuccess" v-if="scope.row.enable">启用</span>
          <span class="textWarning" v-else>禁用</span>
        </template>
      </el-table-column>
      <el-table-column
        class-name="operation"
        label="操作"
        align="center"
        width="130px"
      >
        <template slot-scope="scope">
          <el-tooltip
            class="item"
            effect="dark"
            content="新建"
            placement="top"
            :open-delay="300"
          >
            <i
              @click="addOrgType($event, scope.row)"
              class="el-icon-plus"
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="修改"
            placement="top"
            :open-delay="300"
          >
            <i
              @click="editOrgType($event, scope.row)"
              class="el-icon-edit"
            ></i>
          </el-tooltip>
          <el-tooltip
            v-if="scope.row.enable"
            class="item"
            effect="dark"
            content="禁用"
            placement="top"
            :open-delay="300"
          >
            <i
              @click="disableOrg($event, scope.row)"
              class="iconfont icon-jinyong"
            ></i>
          </el-tooltip>
          <el-tooltip
            v-else
            class="item"
            effect="dark"
            content="启用"
            placement="top"
            :open-delay="300"
          >
            <i
              @click="enableOrg($event, scope.row)"
              class="iconfont icon-qiyong"
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="上移"
            placement="top"
            :open-delay="300"
          >
            <i
              @click="moveUpOrg($event, scope.row)"
              class="el-icon-arrow-up"
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="下移"
            placement="top"
            :open-delay="300"
          >
            <i
              @click="moveDownOrg($event, scope.row)"
              class="el-icon-arrow-down"
            ></i>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { apiOrgTypeTable } from "@/api/userApi.js";
export default {
  data() {
    return {
      orgTypeData: [],
    };
  },
  methods: {
    // 组织结构类别表格
    async getOrgTypeTable(remove, callback) {
      if (remove != "noRemove") {
        this.orgTypeData = [];
      }
      const res = await apiOrgTypeTable();
      // console.log(res);
      if (res.code == 0) {
        this.orgTypeData = res.data;
        this.$parent.getOrgTypeList();
        if (callback) callback();
      }
    },
    // 新建
    addOrgType(e, row) {
      this.$parent.addNewBtn(e, row);
    },
    // 修改
    editOrgType(e, row) {
      this.$parent.editOrgInfo(e, row);
    },
    // 禁用
    disableOrg(e, row) {
      this.$parent.disableOrg(e, row);
    },
    // 启用
    enableOrg(e, row) {
      this.$parent.enableOrg(e, row);
    },
    // 上移
    moveUpOrg(e, row) {
      this.$parent.moveUpOrg(e, row);
    },
    // 下移
    moveDownOrg(e, row) {
      this.$parent.moveDownOrg(e, row);
    },
  },
};
</script>

<style lang="less" scoped>
.orgTypePage {
  height: 100%;
}
</style>